import React, { useState, useEffect } from 'react';
import {Route, Routes} from 'react-router-dom';
import AppRoutes from './AppRoutes';
import { Layout } from './components/Layout';
import './resources/css/reset.css';
import './resources/css/app.css';
import {Snackbar} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey('5a9d8cffa27a9ade40c567bedb8a99b4Tz03NTM2OCxFPTE3MjcxODI0MDgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');


const vertical = 'top';
const horizontal = 'center';

const MOBILE_MAX_WIDTH = 768;
const TABLET_MAX_WIDTH = 1280;

/**
 * Buckets the viewport width. Storing the bucket rather than the raw pixel width means a resize only
 * re-renders the app when the layout actually needs to change - React bails out when the state value
 * is unchanged, so dragging a window edge no longer re-renders every route on each resize event.
 */
function getBreakpoint(width) {
    if (width <= MOBILE_MAX_WIDTH) {
        return 'mobile';
    }

    if (width <= TABLET_MAX_WIDTH) {
        return 'tablet';
    }

    return 'desktop';
}

const Alert = React.forwardRef(function Alert (props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function App() {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
    const [breakpoint, setBreakpoint] = useState(() => getBreakpoint(window.innerWidth));

    function handleWindowSizeChange() {
        setBreakpoint(getBreakpoint(window.innerWidth));
    }

    const isMobile = breakpoint === 'mobile';
    const isTablet = breakpoint === 'tablet';
    const isDesktop = breakpoint === 'desktop';

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return() => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    function resetSnackbar () {
        setSnackbarMessage('');
        setSnackbarSeverity('success');
    }

    function closeSnackbar (event, reason) {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen(false);
    }

    function setSnackbarProperties (message, severity) {
        setSnackbarMessage(message ?? '');
        setSnackbarSeverity(severity ?? 'success');
        setSnackbarOpen(true);
    }


    return (
        <>
            <Layout isMobile={isMobile} isTablet={isTablet} isDesktop={isDesktop}>
                <Routes>
                    {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} {...rest} element={React.cloneElement(element, { setSnackbarProperties, isMobile, isTablet, isDesktop })}/>;
                    })}
                </Routes>
            </Layout>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                key={'topcenter'}
                anchorOrigin={{ vertical, horizontal }}
                onClose={closeSnackbar}
                TransitionProps={{
                    onExited: () => {
                        resetSnackbar();
                    }
                }}
            >
                <Alert
                    severity={snackbarSeverity}
                    sx={{ width: '100%' }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </>
    );
}
